import {
  Div, FormLayout, Group, Panel, Title
} from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import { FC, useCallback, useMemo } from 'react';
import { AppPanelsT } from 'src/app/providers/RouteProvider/lib/routeConfig';
import {
  $firstStageVotes, $pollItems, PretendentsGate, setPretendents
} from 'src/entity/Pretendents';
import { $isStandAlone } from 'src/entity/User';

import { setActivePanel } from 'src/entity/ActivePanel';
import { postVotes } from 'src/features/postVotes';
import compos from 'src/shared/assets/images/compos.png';
import { IVotes } from 'src/shared/config';
import { Cover } from 'src/shared/ui/cover';
import { SuperBtn } from 'src/shared/ui/superBtn';
import { VoitingInput } from './VoitingInput/VoitingInput';
import styles from './styles.module.scss';

export interface IVoitingPanel {
  id: AppPanelsT;
}

export const VoitingPanel: FC<IVoitingPanel> = ({ id }) => {
  const [
    pollItmes,
    onSetPretendents,
    firstStageVotes,
    onPostVotes,
    isStandalone
  ] = useUnit([
    $pollItems,
    setPretendents,
    $firstStageVotes,
    postVotes,
    $isStandAlone
  ]);

  const onInputChange = useCallback(
    (pretendent: IVotes) => {
      onSetPretendents(pretendent);
    },
    [onSetPretendents]
  );

  const inputs = useMemo(
    () => pollItmes.map(({ label, name }) => (
      <VoitingInput
        key={name}
        label={label}
        name={name}
        onChange={onInputChange}
        firstStageVotes={firstStageVotes}
      />
    )),
    [pollItmes, onInputChange, firstStageVotes]
  );

  return (
    <Panel id={id}>
      <PretendentsGate />
      <Group>
        {!isStandalone && (
          <Title level='2' className={styles.title}>
            Заполняй форму и предлагай своих претендентов в каждой из 12
            номинаций!
          </Title>
        )}

        {isStandalone && (
          <Title level='2' className={styles.titleDesktop}>
            Предлагай своих претендентов в каждой из 12 номинаций!
          </Title>
        )}

        {!isStandalone && (
          <Div className={styles.sub_title}>
            <img width={300} src={compos} alt='compos' />
          </Div>
        )}

        <Div className={styles.poll__form}>
          <FormLayout className={styles.form}>
            {inputs}
            <SuperBtn
              size='m'
              color='3'
              className={styles.button}
              onClick={onPostVotes}
              text='Отправить'
            />
          </FormLayout>
        </Div>
      </Group>
      <Cover />
    </Panel>
  );
};
